// extracted by mini-css-extract-plugin
export default {"pointer":"Calendar_pointer__clExY","prevMonth":"Calendar_prevMonth__2K2nL","nextMonth":"Calendar_nextMonth__sTOih","yearMonth":"Calendar_yearMonth__gzkGv"};